import React, { useEffect, useState, useRef } from 'react';
import { Divider, Select, MenuItem, Card, Tooltip } from '@mui/material';
import { Key } from 'lucide-react';
import { makeStyles } from "@material-ui/core/styles";
import { LightenDarkenColor } from 'lighten-darken-color';
import { dataService } from '../../../Services/data/data.service';
import DataListIcon from './DataList.svg';

function DataList(props) {
    const [datalistValue, setDatalistValue] = useState("")
    const [listItems, setListItems] = useState([]);
    const classes = useStyles();

    const titleRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            if (titleRef.current) {
                const element = titleRef.current;

                // Temporarily remove the clamp styles to measure natural height
                const originalStyle = element.style.webkitLineClamp;
                element.style.webkitLineClamp = "unset";
                element.style.display = "block";

                // Measure natural height
                const naturalHeight = element.getBoundingClientRect().height;

                // Restore original styles
                element.style.webkitLineClamp = originalStyle;
                element.style.display = "-webkit-box";

                // Get line height dynamically
                const lineHeight = parseFloat(window.getComputedStyle(element).lineHeight);
                const maxHeight = lineHeight * 2; // Two lines

                setIsOverflowing(naturalHeight > maxHeight);
            }
        };

        checkOverflow();
        window.addEventListener("resize", checkOverflow);
        return () => window.removeEventListener("resize", checkOverflow);
    }, [props.description]);

    const titleElement = (
        <h2 ref={titleRef} style={{ color: `${props.textColor} !important` }} className={classes.h2style}>
            {props.description}
        </h2>
    );

    useEffect(() => {
        dataService.getListItemsByListIdAndProjectGuid(props.dataListId, props.projectGuid).then(result => {
            setListItems(result.sort((a, b) => a.name.localeCompare(b.name)));
        });
        setDatalistValue("")
        // eslint-disable-next-line 
    }, [props.refresh])

    const handleSelect = (e) => {
        setDatalistValue(e.target.value)
        props.setDataValue(e.target.value, props.id)
    }

    return (
        <Card>
            <div className={classes.freeText} style={{ color: props.textColor, backgroundColor: `${props.color}` }}>
                <div className={classes.headerDiv} style={{ color: `${props.textColor} !important` }}>
                    {props.isKey && <Key className={classes.keyStyle}></Key>}
                    {isOverflowing ? (
                        <Tooltip title={props.description} placement="top" arrow>
                            {titleElement}
                        </Tooltip>
                    ) : (
                        titleElement
                    )}
                    <img className={classes.imageStyle} style={{ filter: props.darkness ? 'invert(1)' : 'contrast(80%)' }} src={DataListIcon} alt="" />
                </div>
                <Divider></Divider>
                <div className={classes.textDiv} style={{ color: props.textColor, backgroundColor: LightenDarkenColor(props.color, 20) }}>
                    <Select
                        style={{ display: 'flex !important', flexDirection: 'column !important' }}
                        value={datalistValue}
                        onChange={handleSelect}
                        fullWidth >
                        {listItems.map((row, index) => (
                            <MenuItem value={row.name} index={index} >{row.name}</MenuItem>
                        ))}
                    </Select>
                </div>
                <Divider></Divider>
            </div>
        </Card >
    );
}


export default DataList;

const useStyles = makeStyles({

    freeText: {
        overflow: 'hidden',
        backgroundRepeat: "no-repeat",
        backgroundSize: "10rem 10rem",
        backgroundPosition: "center",
        height: "12rem",

    },
    headerDiv: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '33%',
    },
    h2style: {
        margin: '0',
        zIndex: '2',
        maxWidth: 'calc(100% - 150px)',

        // break words if they are too long
        whiteSpace: 'normal',
        textOverflow: 'ellipsis',
        wordWrap: 'break-word',

        // max two lines
        display: '-webkit-box',
        WebkitLineClamp: '2',
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
    },
    imageStyle: {
        position: 'absolute',
        right: '3%',
        opacity: '50%',
        width: '50px'
    },
    keyStyle: {
        position: 'absolute',
        left: '3%',
        opacity: '50%',
        width: '50px'
    },
    textDiv: {
        paddingLeft: '15px',
        paddingRight: '15px',
        display: "flex",
        justifyContent: "center",
        height: '34%',
        alignItems: 'center',
    },
    StyleDiv: {
        height: '33%',
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        alignItems: 'center',
    },
});